import { format, getTime, formatDistanceToNow, parseISO } from 'date-fns';

// ----------------------------------------------------------------------

export function fDate(date, newFormat) {
  if(!date) return '';
  const fm = newFormat || 'dd MMM yyyy';

  return date ? format(new Date(date), fm) : '';
}

export function fDateTime(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy p';

  return date ? format(new Date(date), fm) : '';
}
export function fTime(time){
  if(!time) return '';
  return time ? format(new Date(time), 'p') : '';
}

export function fTimestamp(date) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
      })
    : '';
}

export function formatDate(dateString, formatPattern = 'dd/MM/yyyy') {
  if(!dateString) return '';  
  return format(parseISO(dateString), formatPattern);
}

export function formatTime12(date) {
  if (!date) return '';
  const dateObj = typeof date === 'string' ? parseISO(date) : new Date(date);
  return format(dateObj, 'hh:mm a'); // 12-hour format: 08:00 PM
}

// ----------------------------------------------------------------------

/**
 * Convert milliseconds to a human-readable duration string.
 * Examples:
 *   0           -> "0s"
 *   65000       -> "1m 5s"
 *   3661000     -> "1h 1m 1s"
 *
 * @param {number} ms  Milliseconds
 * @returns {string}    Formatted duration
 */
export function fDuration(ms) {
  if (ms == null || ms === '') return '';

  // convert string representations of numbers to numeric value
  const value = typeof ms === 'string' ? Number(ms) : ms;

  // if not a valid number, assume it's already formatted and return as-is
  if (Number.isNaN(value)) return ms;

  const totalSeconds = Math.floor(value / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  // build parts, always show seconds (even 0s) for clarity
  const parts = [];
  if (hours) parts.push(`${hours}h`);
  if (minutes) parts.push(`${minutes}m`);
  parts.push(`${seconds}s`);

  return parts.join(' ');
}
